var n={},o=function(o){n=o},r=function(o){var r;return(null===(r=n)||void 0===r?void 0:r[o])||""};export{r as g,o as s};
